import React from "react"
import { navigate } from "gatsby";
import { toast } from "react-toastify";
import { detectDifficulty, apiCall, url_base } from "../../../Helper"

export default ({ show, toggleShow, full, exam, setIsLoading }) => {

  function takeExam() {
    setIsLoading(true)
    apiCall({
      url: '/newExams/activeExam',
      data: { exam_id: exam.id },
      method: 'post'
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        if (res.data.code === 0)
          navigate(`/exam/list/${res.data.e_id}`)
        else toast.warn(res.data.msg || "آزمون قابل شرکت نیست")
      } else toast.error('مشکل در سیستم')
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  return (
    show ? <div className={`modal flexed fl-c` + (full && ' full')}>
      <div className={`pb-32 overflow-hidden` + (full && ' bg-top-nav w-50 shadow-mild radius-8 popIn')}>
        {/* <h3 className="m-0 text-shadow font-16 px-8">آزمون غیر قابل دسترس</h3>
        <hr className="mb-0" /> */}
        <div className="modal-content">
          <div className="bg-top-nav exam-item radius-4 p-64 pb-32 overflow-hidden">
            <div className="tag bg-tomato absolute text-top-nav text-center p-4">{exam?.price ? (exam.price + ' تومان') : 'رایگان'}</div>
            <div className="flexed align-c">
              <div className="flex-1 grid pb-16 pl-32">
                <div>
                  <h3 className="mt-0 font-16 text-shadow pb-16">کد {exam.id} - {exam?.title}</h3>
                </div>
                <div className="font-11 flexed">
                  <div className="flex-2">
                    <span>گروه: </span>
                    <span className="bold">{exam?.group?.title || 'ندارد'}</span>
                  </div>

                  <div className="flex-1 pr-2" style={{ transform: 'translateX(-32px)' }}>
                    <span>حدنصاب: </span>
                    <span className="bold">{exam?.pass_percent}٪</span>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="grid pt-16 font-11" style={{ gridTemplateColumns: 'repeat(3, 1fr)', gridGap: 16 }}>
                <div>
                  <span>تعداد سوال: </span>
                  <span className="bold">{exam?.q_count} عدد</span>
                </div>
                <div className="text-center">
                  <span>سطح: </span>
                  <span className="bold">{detectDifficulty(exam?.difficulty)}</span>
                </div>
                <div>
                  <span>مدت زمان: </span>
                  <span className="bold">{exam?.time} دقیقه</span>
                </div>
              </div>
            </div>

            {exam.description && <div className="pt-22">
              <p className="iran-sans-light line-2">
                {exam.description}
              </p>
            </div>}

          </div>
        </div>
        <div className="ltr px-32">
          {(exam.price === 0 || exam.has_bought) ? <button className="bd-none iran-sans radius-4 font-10 text-top-nav bg-tomato"
            style={{ padding: '5px 16px', width: 100 }} onClick={takeExam}>
            شروع آزمون
          </button> :
            <a href={url_base + '/shop/exam/' + exam.id} target="_blank">
              <button className="bd-none iran-sans radius-4 font-10 text-top-nav bg-tomato"
                style={{ padding: '5px 16px', width: 100 }}>
                خرید آزمون
              </button>
            </a>}
          <button className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-top-nav ml-16"
            onClick={() => toggleShow(false)}
            style={{ color: 'var(--tomato)', padding: '5px 0', width: 100, border: '1px solid var(--tomato)' }}>بستن</button>
        </div>

      </div>
    </div> : <div></div>
  )
}
